function b(u, t, s) {
  let e = 0;
  return Math.abs(u - t[0]) < Math.abs(t[1] - u) ? e = t[0] - s : e = t[1] + s, e;
}
export {
  b as moveOutOfRange
};
//# sourceMappingURL=index7.js.map
